import { Button } from '@cian/ui-kit';
import { IconActionChevronDown16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ScrollButton.css';

type TProps = {
  onClick: () => void;
};

export const ScrollButton: React.FC<TProps> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <span className={styles['button']}>
        <Button
          title=""
          beforeIcon={<IconActionChevronDown16 color="current_color" />}
          theme="fill_white_primary"
          size="M"
          onClick={onClick}
        />
      </span>
    </div>
  );
};
